/* globals woosmap sessionStorage */

function getCountryAndLang () {
    var country = $('#country-code').val() || '';
    var contentLang = $('meta[http-equiv=content-language]').attr('content') || '';
    var language = '';
    if (contentLang) {
        language = contentLang.split('-')[0] || '';
    }
    var countryList = [];
    if (country) {
        country = country.toLowerCase();
        countryList = [country];
    } else {
        country = contentLang.split('-')[1] || '';
        if (country) {
            countryList = [country];
        }
    }

    // Fix for Hong Kong
    if (countryList[0] && countryList[0].toLowerCase() === 'hk') {
        countryList = ['cn'];
    }

    return [countryList, language];
}

function getQueryMinimumLength (countryList) {
    var country = countryList[0];

    /* eslint-disable */
    switch (country) {
        case 'JP' :
        case 'jp' :
        case 'HK' :
        case 'hk' :
            return 2;
        default :
            return 3;
    }
    /* eslint-enable */
}

function woosmapInitFindInStore () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];
    var minimumLength = getQueryMinimumLength(countryList);

    let localitiesWidgetFindInStore = new woosmap.localities.Autocomplete(
        'input-text-woosmap-findinstore', {
            'minLength': minimumLength,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );
    localitiesWidgetFindInStore.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetFindInStore.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionFindInStore', selection);
    });

    $('body').on('woosmap:modalClose', function (_e) {
        localitiesWidgetFindInStore.removeListener('selected_suggestion');
        $(localitiesWidgetFindInStore.resultsContainer).addClass('hidden');
    });
}

function woosmapInitUPS () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    let localitiesWidgetUPS = new woosmap.localities.Autocomplete(
        'input-text-woosmap-ups', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );
    localitiesWidgetUPS.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetUPS.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionUPS', selection);
    });

    $('body').on('woosmap:modalClose', function (_e) {
        localitiesWidgetUPS.removeListener('selected_suggestion');
        $(localitiesWidgetUPS.resultsContainer).addClass('hidden');
    });
}

function woosmapInitInPost () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    let localitiesWidgetInPost = new woosmap.localities.Autocomplete(
        'input-text-woosmap-inpost', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );

    localitiesWidgetInPost.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetInPost.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionInPost', selection);
    });

    $('body').on('woosmap:modalClose', function (_e) {
        localitiesWidgetInPost.removeListener('selected_suggestion');
        $(localitiesWidgetInPost.resultsContainer).addClass('hidden');
    });
}

function woosmapInitPPL () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    // PPL
    let localitiesWidgetPPL = new woosmap.localities.Autocomplete(
        'input-text-woosmap-ppl', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );

    localitiesWidgetPPL.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetPPL.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionPPL', selection);
    });

    $('body').on('woosmap:modalClose', function (_e) {
        localitiesWidgetPPL.removeListener('selected_suggestion');
        $(localitiesWidgetPPL.resultsContainer).addClass('hidden');
    });
}

function woosmapInitBRT () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    let localitiesWidgetBRT = new woosmap.localities.Autocomplete(
        'input-text-woosmap-brt', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );

    localitiesWidgetBRT.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetBRT.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionBRT', selection);
    });

    $('body').on('woosmap:modalClose', function (_e) {
        localitiesWidgetBRT.removeListener('selected_suggestion');
        $(localitiesWidgetBRT.resultsContainer).addClass('hidden');
    });
}

function woosmapInitFindYourStoreMenu () {
    if (!$('#store-locator-menu').length) {
        return;
    }

    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];
    var minimumLength = getQueryMinimumLength(countryList);

    let localitiesWidgetMenu = new woosmap.localities.Autocomplete(
        'store-locator-menu', {
            'minLength': minimumLength,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );

    localitiesWidgetMenu.addListener('selected_suggestion', () => {
        let inputValue = $('#store-locator-menu').val();

        let redirectUrl = $('#store-locator-menu').closest('[data-url]').data('url');
        let selectionMenu = localitiesWidgetMenu.getSelectedSuggestionDetails();
        selectionMenu = JSON.stringify(selectionMenu);

        sessionStorage.setItem('selectionMenu', selectionMenu);
        sessionStorage.setItem('inputValue', inputValue);

        window.location.href = redirectUrl;
    });
}

function woosmapInitFindYourStore (filterByCountry = true) {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];
    var minimumLength = getQueryMinimumLength(countryList);

    var config = {};
    if (filterByCountry) {
        config = {
            'minLength': minimumLength,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        };
    } else {
        config = {
            'minLength': minimumLength,
            'data': 'advanced',
            'language': language
        };
    }

    let localitiesWidgetFindYourStore = new woosmap.localities.Autocomplete('store-postal-code', config);
    localitiesWidgetFindYourStore.addListener('selected_suggestion', () => {
        var selection = localitiesWidgetFindYourStore.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionFindYourStore', selection);
    });

    $('body').on('woosmap:openDropdownStoreLocator', () => {
        localitiesWidgetFindYourStore.predictions();
    });
}

function woosmapInitFooter (filterByCountry = true) {
    const _initWoosmap = () => {
        if (!$('#footer-find-store').length) {
            return;
        }

        var countryAndLang = getCountryAndLang();
        var countryList = countryAndLang[0];
        var language = countryAndLang[1];
        var minimumLength = getQueryMinimumLength(countryList);

        var config = {};
        if (filterByCountry) {
            config = {
                'minLength': minimumLength,
                'components': {
                    'country': countryList
                },
                'data': 'advanced',
                'language': language
            };
        } else {
            config = {
                'minLength': minimumLength,
                'data': 'advanced',
                'language': language
            };
        }

        // eslint-disable-next-line no-undef la
        let localitiesWidgetFooter = new woosmap.localities.Autocomplete('footer-find-store', config);

        localitiesWidgetFooter.addListener('selected_suggestion', () => {
            let selection = localitiesWidgetFooter.getSelectedSuggestionDetails();
            $('body').trigger('woosmap:chooseOptionFooter', selection);
        });
    };

    if (window.woosmap) {
        _initWoosmap();
    } else {
        $('body').on('woosmap:loaded', _initWoosmap);
    }
}

function woosmapInitSPS () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    let localitiesWidgetSPS = new woosmap.localities.Autocomplete(
        'input-text-woosmap-sps', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );
    localitiesWidgetSPS.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetSPS.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionSPS', selection);
    });
}

function woosmapInitRUPup () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    // RU PUP
    let localitiesWidgetRUPup = new woosmap.localities.Autocomplete(
        'input-text-woosmap-ru-pup', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'language': language
        }
    );

    localitiesWidgetRUPup.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetRUPup.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionRuPup', selection);
    });

    $('body').on('woosmap:modalClose', function (_e) {
        localitiesWidgetRUPup.removeListener('selected_suggestion');
        $(localitiesWidgetRUPup.resultsContainer).addClass('hidden');
    });
}

function woosmapInitDHL () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    // DHL
    let localitiesWidgetDHL = new woosmap.localities.Autocomplete(
        'input-text-woosmap-dhl', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );
    localitiesWidgetDHL.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetDHL.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionDHL', selection);
    });
}

function woosmapInitDPD () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    // DPD
    let localitiesWidgetDPD = new woosmap.localities.Autocomplete(
        'input-text-woosmap-dpd', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );
    localitiesWidgetDPD.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetDPD.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionDPD', selection);
    });
}

function woosmapInitHermes () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    // Hermes
    let localitiesWidgetHermes = new woosmap.localities.Autocomplete(
        'input-text-woosmap-hermes', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );
    localitiesWidgetHermes.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetHermes.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionHermes', selection);
    });
}

function woosmapListenerForModalClose () {
    $('body').on('click', '.tingle-modal:not(.express-button-modal)', (e) => {
        /**
         * Mandatory classes to skip the trigger below for return flow. "isReturnFlow" is TRUE if the target action is:
         * (1) CTA find in store.
         * (2) CTA proceed.
         * (3) CTA edit store
         */
        var isReturnFlow = $(e.target).hasClass('js-returnOpen-searchStores') || $(e.target).hasClass('js-returnOpen-footer_buttonProceed') || $(e.target).closest('.js-returnOpen-shippingMethod_editStore').length > 0;

        if (e.target.className === '' || isReturnFlow) {
            return;
        }
        $('body').trigger('woosmap:modalClose');
    });
    $('body').on('click', '.modal-close:not(.modal-close-express)', (e) => {
        $('body').trigger('woosmap:modalClose');
    });
}

function woosmapInitCollissimo () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    // Collissimo
    let localitiesWidgetCollisimo = new woosmap.localities.Autocomplete(
        'input-text-woosmap-collissimo', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );

    localitiesWidgetCollisimo.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetCollisimo.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionCLSS', selection);
    });

    $('body').on('woosmap:modalClose', function (_e) {
        localitiesWidgetCollisimo.removeListener('selected_suggestion');
        $(localitiesWidgetCollisimo.resultsContainer).addClass('hidden');
    });
}

// TODO: DELETE AFTER REFACTORING FILE pickupPoint.js ON EME
function woosmapInitPDB () {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    let localitiesWidgetPDB = new woosmap.localities.Autocomplete(
        'input-text-woosmap-PDB', {
            'minLength': 3,
            'components': {
                'country': countryList
            },
            'data': 'advanced',
            'language': language
        }
    );

    localitiesWidgetPDB.addListener('selected_suggestion', () => {
        let selection = localitiesWidgetPDB.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionPDB', selection);
    });

    $('body').on('woosmap:modalClose', function (_e) {
        localitiesWidgetPDB.removeListener('selected_suggestion');
        $(localitiesWidgetPDB.resultsContainer).addClass('hidden');
    });

    $('body').on('click', '#pickupPointPDB input[name="pickup-point-service-type"]', (e) => {
        e.stopPropagation();

        let selection = localitiesWidgetPDB.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:chooseOptionPDB', selection);
    });
}

function woosmapInitPudoBFF (shippingMethodType) {
    var countryAndLang = getCountryAndLang();
    var countryList = countryAndLang[0];
    var language = countryAndLang[1];

    let localitiesWidget;

    // switch case for customizations on shippingMethodType
    switch (shippingMethodType) {
    case 'CTT' :
        localitiesWidget = new woosmap.localities.Autocomplete(
            `input-text-woosmap-${shippingMethodType}`, {
                'minLength': 3,
                'components': {
                    'country': countryList
                },
                'data': 'advanced',
                'language': language,
                'types': ['locality', 'postal_code']
            }
        );
        break;
    case 'DEL' :
    case 'GLS' :
    case 'XBS':
        localitiesWidget = new woosmap.localities.Autocomplete(
            `input-text-woosmap-${shippingMethodType}`, {
                'minLength': 3,
                'components': {
                    'country': countryList
                },
                'data': 'advanced',
                'language': language
            }
        );
        break;

    default :
        localitiesWidget = new woosmap.localities.Autocomplete(
            `input-text-woosmap-${shippingMethodType}`, {
                'minLength': 3,
                'components': {
                    'country': countryList
                },
                'data': 'advanced',
                'language': language
            }
        );
        break;
    }

    const pudoModalSelector = `#pickupPoint${shippingMethodType}`;
    const chooseOptionSelector = `chooseOption${shippingMethodType}`;

    localitiesWidget.addListener('selected_suggestion', () => {
        let selection = localitiesWidget.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:' + chooseOptionSelector, selection);
    });

    $('body').on('woosmap:modalClose', function (_e) {
        localitiesWidget.removeListener('selected_suggestion');
        $(localitiesWidget.resultsContainer).addClass('hidden');
    });

    $('body').on('click', pudoModalSelector + ' input[name="pickup-point-service-type"]', (e) => {
        e.stopPropagation();

        let selection = localitiesWidget.getSelectedSuggestionDetails();
        $('body').trigger('woosmap:' + chooseOptionSelector, selection);
    });
}

export {
    woosmapInitFindInStore,
    woosmapInitUPS,
    woosmapInitInPost,
    woosmapInitBRT,
    woosmapInitPPL,
    woosmapInitDHL,
    woosmapInitDPD,
    woosmapInitFindYourStoreMenu,
    woosmapInitFindYourStore,
    woosmapInitSPS,
    woosmapListenerForModalClose,
    woosmapInitFooter,
    woosmapInitRUPup,
    woosmapInitHermes,
    woosmapInitCollissimo,
    woosmapInitPDB,
    woosmapInitPudoBFF
};
